import React from 'react';
import { Typography } from 'antd';
import './FeatureOptions.css';

// 导入图片资源
import myWelfareIcon from "../assets/images/my_welfare.svg";
import lunchIcon from "../assets/images/lunch.svg";
import policyIcon from "../assets/images/policy.svg";

const { Text } = Typography;

// 功能选项数据类型
export interface FeatureOption {
    key: string;
    iconSrc: string;
    title: string;
    description: string;
}

// 功能选项数据
const defaultFeatureOptions: FeatureOption[] = [
    {
        key: "plan",
        iconSrc: myWelfareIcon,
        title: "帮我设计一个福利方案",
        description: "为您的企业量身定制个性化福利解决方案",
    },
    {
        key: "lunch",
        iconSrc: lunchIcon,
        title: "介绍一下用餐产品",
        description: "解决企业用餐难题，员工用餐省心又放心！",
    },
    {
        key: "policy",
        iconSrc: policyIcon,
        title: "帮我总结最新的福利政策",
        description: "获取最新的福利政策解读与建议",
    },
];

interface FeatureOptionsProps {
    onFeatureClick: (option: FeatureOption) => void;
    loading?: boolean;
}

const FeatureOptions: React.FC<FeatureOptionsProps> = ({
    onFeatureClick,
    loading = false,
}) => {
    return (
        <div className="feature-options">
            {defaultFeatureOptions.map((option) => (
                <div
                    key={option.key}
                    className={`feature-card ${loading ? 'feature-card-disabled' : ''}`}
                    onClick={() => !loading && onFeatureClick(option)}
                >
                    <div className="feature-icon-container">
                        <img
                            src={option.iconSrc}
                            alt={option.title}
                            className="feature-icon-image"
                            width={24}
                            height={24}
                        />
                    </div>
                    <div className="feature-content">
                        <Text className="feature-title">{option.title}</Text>
                        <Text className="feature-description">
                            {option.description}
                        </Text>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FeatureOptions;
